import React from 'react';
import KitDeMarcaFullPage from '../components/KitDeMarcaFullPage';
import Footer from '../components/Footer';
import Cart from '../components/Cart';

const KitDeMarcaPage = () => {
  return (
    <>
      <KitDeMarcaFullPage />
      <Cart />
      <Footer />
    </>
  );
};

export default KitDeMarcaPage;
